import { useMemo, useState } from 'react'

export type CampoOrdenacao = 'data' | 'nome' | 'parcela' | 'valor'

/** Ordenação e busca por nome no cliente, pra telas que já carregam a lista inteira
 * (fatura do cartão, painel de conta/cartão, extrato/histórico da Pluggy). */
export function useOrdenarBuscarLocal<T>(itens: T[], acessores: {
  nome: (item: T) => string
  data: (item: T) => string | number | Date
  valor: (item: T) => number
  parcela?: (item: T) => number | null | undefined
}) {
  const [busca, setBusca] = useState('')
  const [ordenarPor, setOrdenarPor] = useState<CampoOrdenacao>('data')
  const [ordemDesc, setOrdemDesc] = useState(true)

  const itensOrdenados = useMemo(() => {
    const filtrados = busca.trim()
      ? itens.filter((i) => acessores.nome(i).toLowerCase().includes(busca.trim().toLowerCase()))
      : itens

    const comparar = (a: T, b: T): number => {
      switch (ordenarPor) {
        case 'nome': return acessores.nome(a).localeCompare(acessores.nome(b))
        case 'valor': return acessores.valor(a) - acessores.valor(b)
        case 'parcela': return (acessores.parcela?.(a) ?? 0) - (acessores.parcela?.(b) ?? 0)
        default: return new Date(acessores.data(a)).getTime() - new Date(acessores.data(b)).getTime()
      }
    }
    const ordenados = [...filtrados].sort(comparar)
    if (ordemDesc) ordenados.reverse()
    return ordenados
  }, [itens, busca, ordenarPor, ordemDesc, acessores])

  function alternarOrdenacao(campo: CampoOrdenacao) {
    setOrdemDesc((atual) => (campo === ordenarPor ? !atual : true))
    setOrdenarPor(campo)
  }

  return { busca, setBusca, ordenarPor, ordemDesc, alternarOrdenacao, itens: itensOrdenados }
}
